module.exports = __webpack_public_path__ + "static/media/reference.d5587ffa.jpg";